import { render, staticRenderFns } from "./TicketTransferReport.vue?vue&type=template&id=2d2030cc&scoped=true&"
import script from "./TicketTransferReport.vue?vue&type=script&lang=js&"
export * from "./TicketTransferReport.vue?vue&type=script&lang=js&"
import style0 from "./TicketTransferReport.vue?vue&type=style&index=0&id=2d2030cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2030cc",
  null
  
)

export default component.exports